const $ = jQuery.noConflict();

class StoriesPosts {
    constructor(postsWrapper, loadMoreButton, postType, taxonomy) {
        this.postsWrapper = postsWrapper;
        this.loadMoreButton = loadMoreButton;
        this.postType = postType;
        this.taxonomy = taxonomy;
    }

    init() {
        this.initMasonry();
        this.bindEvents();
    }

    initMasonry() {
        $(this.postsWrapper).isotope({
            // options
            itemSelector: '.stories-post',
            percentPosition: true,
            masonry: {
                // use element for option
                columnWidth: '.stories-post--default',
            },
        });
    }

    bindEvents() {
        $(this.loadMoreButton).on('click', (e) => this.loadMorePosts(e));
    }

    loadMorePosts() {
        let allowAjax = true;
        const imgLoader = `<img src="${WP.templateUrl}/images/gifs/loading.gif" alt="loading" class="stories-loader"/>`;

        let ajaxData = {
            action: 'load_more_stories',
            postType: this.postType,
            taxonomy: this.taxonomy,
            offset: parseInt($(this.postsWrapper).attr('data-offset'), 10),
        };

        if (typeof ($(this.postsWrapper).attr('data-taxonomy-value')) === 'string') {
            ajaxData.taxonomyValue = $(this.postsWrapper).attr('data-taxonomy-value');
        }

        if (allowAjax) {
            $.ajax({
                type: 'POST',
                url: WP.ajaxUrl,
                data: ajaxData,
                beforeSend: () => {
                    allowAjax = false;
                    $(imgLoader).insertBefore($(this.loadMoreButton));
                },
                success: (data) => {
                    allowAjax = true;
                    $('.stories-loader').detach();

                    const posts = $.parseHTML(data);
                    console.log(posts);
                    const postsCount = posts.length / 2;
                    $(this.postsWrapper).attr('data-offset', parseInt($(this.postsWrapper).attr('data-offset'), 10) + postsCount);
                    $(this.postsWrapper).append(posts).isotope('appended', posts);

                    if (parseInt($(this.postsWrapper).attr('data-offset'), 10) >= parseInt($(this.postsWrapper).attr('data-total-posts'), 10)) {
                        $(this.loadMoreButton).detach();
                    }
                },
            });
        }
    }
}

export default new StoriesPosts('.stories-posts', '.stories-load-more', 'stories', 'stories-category');
